

module.exports = __webpack_require__.stylable.create(
    "Button1434182190",
    {"classes":{"root":"Button1434182190__root"},"vars":{"button-border-radius":"--Button1434182190-button-border-radius"},"stVars":{},"keyframes":{}},
    "",
    8,
    "Button1434182190",
    null
);
